export const ROUTES_PATH = {
  LOGIN: "/login",
  LOGOUT: "/logout",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/User/ResetPassword",
  USER_PROFILE: "/user/user-profile",
  CHANGE_PASSWORD: "/user/change-password",
  HOMEPAGE: "/",
  REGISTRATION: "/register",
  SAVE_CONFIGURATION: "/save-configuration",
  SHARE_DESIGN_1: "/share-design-1",
  SHARE_DESIGN_2: "/share-design-2",
  LOOKUP_CONFIG: "/lookup-config",
  CAPTURE_DESIGN: "/capture-design",
  RAWLINGS: "https://www.rawlings.com/",
};
